// C10 · مطالبات الموظفين (employee claims) — per-screen i18n namespace.
// module.exports = { ar: { claims: {...} }, en: { claims: {...} } }, merged at
// load time by i18n.ts's require.context('./screens'). Full ar/en parity.
module.exports = {
  ar: {
    claims: {
      title: 'مطالبات الموظفين',
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل المطالبات',
      empty: 'لا توجد مطالبات مطابقة للفلتر.',
      searchPlaceholder: 'رقم مطالبة / نوع خدمة / مقدّم خدمة',
      export: 'تصدير',
      filtersLabel: 'فلاتر:',
      allStatuses: 'كل الحالات',
      hrNote: 'يتابع قسم الموارد البشرية الحالة فقط — أما قرار القبول أو الرفض فيتخذه مراجع شركة التأمين على لوحة تحكم الأدمن.',
      tableTitle: 'عرض جدول',
      currency: 'ج',
      view: 'عرض',
      hide: 'إخفاء',
      status: {
        registered: 'اتسجّلت',
        at_insurer: 'عند التأمين',
        missing_doc: 'ناقصها مستند',
        accepted: 'اتقبلت',
        rejected: 'اترفضت',
      },
      th: {
        no: 'رقم',
        employee: 'الموظف',
        branch: 'الفرع / البوليصة',
        type: 'النوع',
        amount: 'المبلغ',
        date: 'التاريخ',
        status: 'الحالة',
      },
      detail: {
        provider: 'مقدّم الخدمة',
        invoiceNo: 'رقم الفاتورة',
        invoiceDate: 'تاريخ الفاتورة',
        decidedAmount: 'المبلغ المعتمد',
        source: 'المصدر',
        status: 'الحالة',
        reason: 'سبب قرار المراجع',
        noReason: 'لا يوجد سبب مسجّل بعد',
        documents: 'المستندات',
        openDoc: 'فتح المستند {n}',
        noDocs: 'لا توجد مستندات مرفقة',
        docError: 'تعذّر فتح المستند — ربما لا تملك صلاحية الوصول إليه',
      },
      adjudication: {
        title: 'تفصيل احتساب التغطية',
        none: 'لم يُحتسب التفصيل بعد — يظهر بعد موافقة شركة التأمين على المطالبة.',
        claimAmount: 'مبلغ المطالبة',
        covered: 'المغطّى',
        employeeShare: 'نصيب الموظف',
        decided: 'المبلغ المعتمد',
        capRemaining: 'المتبقي من السقف',
        overridden: 'المراجع اعتمد مبلغًا أقل من المبلغ المغطّى.',
        rule: 'القاعدة',
        detail: 'التفاصيل',
        before: 'قبل',
        after: 'بعد',
        noRules: 'لم تُطبَّق أي قاعدة تخفيض.',
        rules: {
          DEDUCTIBLE_PCT: 'نسبة التحمّل',
          COPAY_PCT: 'المشاركة (Copay)',
          BENEFIT_LIMIT: 'حد المنفعة',
          ANNUAL_CAP: 'السقف السنوي',
        },
      },
      create: {
        open: 'مطالبة جديدة',
        title: 'تقديم مطالبة لموظف',
        cancel: 'إلغاء',
        employee: 'الموظف',
        employeePlaceholder: 'اختر الموظف',
        amount: 'المبلغ',
        serviceDate: 'تاريخ الخدمة',
        provider: 'مقدّم الخدمة',
        note: 'ملاحظات (اختياري)',
        policy: 'البوليصة (اختياري)',
        policyDefault: 'البوليصة الأساسية للموظف',
        policyHint: 'اتركها كما هي لاستخدام بوليصة الموظف الأساسية، أو اختر بوليصة أخرى سارية للشركة (مثل سيارات أو حياة).',
        attach: {
          label: 'مستندات المطالبة (اختياري)',
          hint: 'PDF أو PNG أو JPG، حتى {n} ملفات وبحد أقصى 10 ميجابايت للملف.',
          uploaded: 'تم رفع {n} مستند(ات).',
          kinds: { invoice: 'فاتورة', report: 'تقرير طبي', prescription: 'روشتة', other: 'أخرى' },
          errors: {
            type: 'نوع الملف غير مدعوم',
            empty: 'الملف فارغ',
            size: 'الملف أكبر من 10 ميجابايت',
            count: 'تجاوزت الحد الأقصى لعدد الملفات',
          },
          apiErrors: {
            CLAIM_ALREADY_DECIDED: 'المطالبة تم البتّ فيها ولا تقبل مستندات',
            PAYLOAD_TOO_LARGE: 'الملف كبير جدًا',
            INVALID_FILE: 'ملف غير صالح',
            FORBIDDEN: 'ليس لديك صلاحية رفع مستندات',
            network: 'تعذّر الاتصال بالخادم',
            generic: 'تعذّر رفع الملف',
          },
        },
        documentsNote: 'مستندات المطالبة (الفواتير والتقارير) يرفعها الموظف من تطبيق الموبايل، ويراها المراجع وقسم الموارد البشرية من تفاصيل المطالبة.',
        submit: 'تقديم المطالبة',
        submitting: 'جارٍ التقديم…',
        success: 'تم تقديم المطالبة رقم {id} وهي الآن بانتظار مراجعة شركة التأمين.',
        fixErrors: 'يرجى تصحيح الحقول المحددة أدناه.',
        errors: {
          employeeRequired: 'اختر الموظف',
          amountRequired: 'أدخل المبلغ',
          amountInvalid: 'المبلغ غير صالح (أرقام فقط وحتى منزلتين عشريتين)',
          amountPositive: 'يجب أن يكون المبلغ أكبر من صفر',
          amountTooLarge: 'المبلغ كبير جدًا',
          dateRequired: 'أدخل تاريخ الخدمة',
          dateInvalid: 'التاريخ غير صالح',
          dateFuture: 'تاريخ الخدمة لا يمكن أن يكون في المستقبل',
          providerRequired: 'أدخل اسم مقدّم الخدمة',
          providerTooLong: 'اسم مقدّم الخدمة طويل جدًا (200 حرف كحد أقصى)',
          noteTooLong: 'الملاحظات طويلة جدًا (1000 حرف كحد أقصى)',
        },
        apiErrors: {
          INVALID_AMOUNT: 'المبلغ غير صالح',
          INVALID_REFERENCE: 'أحد المستندات المرجعية غير صالح',
          INVALID_SERVICE_DATE: 'تاريخ الخدمة غير صالح (لا يمكن أن يكون في المستقبل)',
          EMPLOYEE_NOT_FOUND: 'الموظف غير موجود في شركتك',
          EMPLOYEE_NOT_ACTIVE: 'لا يمكن تقديم مطالبة لموظف غير نشط',
          CLAIM_POLICY_REQUIRED: 'هذا الموظف غير مرتبط ببوليصة — اربطه ببوليصة أولاً',
          POLICY_NOT_FOUND: 'البوليصة غير موجودة في شركتك',
          POLICY_NOT_ACTIVE: 'بوليصة الموظف غير سارية',
          SERVICE_DATE_OUT_OF_POLICY: 'تاريخ الخدمة خارج فترة سريان البوليصة',
          VALIDATION_ERROR: 'البيانات المُدخلة غير صالحة — راجع الحقول',
          FORBIDDEN: 'ليس لديك صلاحية تقديم مطالبات',
          NOT_FOUND: 'العنصر المطلوب غير موجود',
          network: 'تعذّر الاتصال بالخادم، حاول مرة أخرى',
          generic: 'تعذّر تقديم المطالبة، حاول مرة أخرى',
        },
      },
      source: {
        mobile: 'تطبيق الموبايل',
        hardcopy: 'نسخة ورقية',
        excel: 'استيراد Excel',
        hr: 'الموارد البشرية',
      },
    },
  },
  en: {
    claims: {
      title: 'Employee claims',
      loading: 'Loading…',
      error: 'Something went wrong while loading claims',
      empty: 'No claims match the current filter.',
      searchPlaceholder: 'Claim no. / service type / provider',
      export: 'Export',
      filtersLabel: 'Filters:',
      allStatuses: 'All statuses',
      hrNote: 'HR only tracks status — the accept/reject decision is made by the insurer reviewer on the admin dashboard.',
      tableTitle: 'Table view',
      currency: 'EGP',
      view: 'View',
      hide: 'Hide',
      status: {
        registered: 'Registered',
        at_insurer: 'At insurer',
        missing_doc: 'Missing document',
        accepted: 'Accepted',
        rejected: 'Rejected',
      },
      th: {
        no: 'No.',
        employee: 'Employee',
        branch: 'Branch / policy',
        type: 'Type',
        amount: 'Amount',
        date: 'Date',
        status: 'Status',
      },
      detail: {
        provider: 'Provider',
        invoiceNo: 'Invoice no.',
        invoiceDate: 'Invoice date',
        decidedAmount: 'Decided amount',
        source: 'Source',
        status: 'Status',
        reason: 'Reviewer decision reason',
        noReason: 'No reason recorded yet',
        documents: 'Documents',
        openDoc: 'Open document {n}',
        noDocs: 'No documents attached',
        docError: 'Could not open the document — you may not have access to it',
      },
      adjudication: {
        title: 'Coverage breakdown',
        none: 'No breakdown yet — it appears once the insurer approves the claim.',
        claimAmount: 'Claim amount',
        covered: 'Covered',
        employeeShare: 'Employee share',
        decided: 'Decided amount',
        capRemaining: 'Cap remaining',
        overridden: 'The reviewer approved less than the covered amount.',
        rule: 'Rule',
        detail: 'Detail',
        before: 'Before',
        after: 'After',
        noRules: 'No reduction rule was applied.',
        rules: {
          DEDUCTIBLE_PCT: 'Deductible',
          COPAY_PCT: 'Copay',
          BENEFIT_LIMIT: 'Benefit limit',
          ANNUAL_CAP: 'Annual cap',
        },
      },
      create: {
        open: 'New claim',
        title: 'Submit a claim for an employee',
        cancel: 'Cancel',
        employee: 'Employee',
        employeePlaceholder: 'Select employee',
        amount: 'Amount',
        serviceDate: 'Service date',
        provider: 'Provider',
        note: 'Note (optional)',
        policy: 'Policy (optional)',
        policyDefault: "Employee's primary policy",
        policyHint: "Leave as is to use the employee's primary policy, or pick another active company policy (e.g. motor or life).",
        attach: {
          label: 'Claim documents (optional)',
          hint: 'PDF, PNG or JPG, up to {n} files and 10 MB per file.',
          uploaded: '{n} document(s) uploaded.',
          kinds: { invoice: 'Invoice', report: 'Medical report', prescription: 'Prescription', other: 'Other' },
          errors: {
            type: 'Unsupported file type',
            empty: 'The file is empty',
            size: 'The file is larger than 10 MB',
            count: 'Maximum number of files exceeded',
          },
          apiErrors: {
            CLAIM_ALREADY_DECIDED: 'The claim is already decided and accepts no documents',
            PAYLOAD_TOO_LARGE: 'The file is too large',
            INVALID_FILE: 'Invalid file',
            FORBIDDEN: 'You do not have permission to upload documents',
            network: 'Could not reach the server',
            generic: 'Could not upload the file',
          },
        },
        documentsNote: 'Claim documents (invoices and reports) are uploaded by the employee from the mobile app; the reviewer and HR see them in the claim details.',
        submit: 'Submit claim',
        submitting: 'Submitting…',
        success: 'Claim #{id} was submitted and is awaiting the insurer review.',
        fixErrors: 'Please fix the highlighted fields below.',
        errors: {
          employeeRequired: 'Select an employee',
          amountRequired: 'Enter the amount',
          amountInvalid: 'Invalid amount (digits only, up to 2 decimals)',
          amountPositive: 'Amount must be greater than zero',
          amountTooLarge: 'Amount is too large',
          dateRequired: 'Enter the service date',
          dateInvalid: 'Invalid date',
          dateFuture: 'Service date cannot be in the future',
          providerRequired: 'Enter the provider name',
          providerTooLong: 'Provider name is too long (max 200 characters)',
          noteTooLong: 'Note is too long (max 1000 characters)',
        },
        apiErrors: {
          INVALID_AMOUNT: 'The amount is invalid',
          INVALID_REFERENCE: 'One of the referenced documents is invalid',
          INVALID_SERVICE_DATE: 'Invalid service date (it cannot be in the future)',
          EMPLOYEE_NOT_FOUND: 'Employee not found in your company',
          EMPLOYEE_NOT_ACTIVE: 'Cannot submit a claim for an inactive employee',
          CLAIM_POLICY_REQUIRED: 'This employee has no policy — assign a policy first',
          POLICY_NOT_FOUND: 'Policy not found in your company',
          POLICY_NOT_ACTIVE: "The employee's policy is not active",
          SERVICE_DATE_OUT_OF_POLICY: "Service date is outside the policy's validity period",
          VALIDATION_ERROR: 'The submitted data is invalid — check the fields',
          FORBIDDEN: 'You do not have permission to submit claims',
          NOT_FOUND: 'The requested item was not found',
          network: 'Could not reach the server, please try again',
          generic: 'Could not submit the claim, please try again',
        },
      },
      source: {
        mobile: 'Mobile app',
        hardcopy: 'Hard copy',
        excel: 'Excel import',
        hr: 'HR portal',
      },
    },
  },
};
